import { useEffect, useState, useCallback } from "react";
import { api, rupee } from "@/lib/api";
import { toast } from "sonner";

const STATUSES = ["awaiting_payment", "confirmed", "processing", "shipped", "delivered", "cancelled", "refunded"];

export default function OrdersAdmin() {
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState("");
  const load = useCallback(() => api.get(`/admin/orders${filter ? `?status=${filter}` : ""}`).then((r) => setOrders(r.data)), [filter]);
  useEffect(() => { load(); }, [load]);

  const update = async (id, status) => {
    await api.put(`/admin/orders/${id}/status?status=${status}`);
    toast.success("Updated"); load();
  };
  const setDelivery = async (id, date) => {
    try { await api.put(`/admin/orders/${id}/delivery-date`, { date }); toast.success("Delivery date updated"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Error"); }
  };

  return (
    <div>
      <h1 className="font-serif text-3xl mb-4">Orders</h1>
      <div className="flex gap-2 mb-4 text-xs uppercase tracking-widest">
        <button onClick={() => setFilter("")} className={`px-3 py-1 ${!filter ? "bg-[#C5A059] text-[#121212]" : "border border-[#27272A]"}`}>All</button>
        {STATUSES.map((s) => (
          <button key={s} onClick={() => setFilter(s)} className={`px-3 py-1 ${filter === s ? "bg-[#C5A059] text-[#121212]" : "border border-[#27272A]"}`} data-testid={`admin-order-filter-${s}`}>{s}</button>
        ))}
      </div>
      <div className="admin-surface overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-[#8C867D] text-xs uppercase tracking-widest text-left">
            <tr><th className="p-3">Order</th><th>Customer</th><th>Items</th><th>Total</th><th>Payment</th><th>Status</th><th>Delivery Date</th><th></th></tr>
          </thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.id} className="border-t border-[#27272A]">
                <td className="p-3 font-mono text-xs">{o.order_id}</td>
                <td>{o.customer_name || "—"}</td>
                <td>{o.items?.length}</td>
                <td>{rupee(o.total)}</td>
                <td className="text-xs uppercase">{o.payment_method}</td>
                <td>
                  <select value={o.status} onChange={(e) => update(o.order_id, e.target.value)} className="admin-input text-xs" data-testid={`admin-order-status-${o.order_id}`}>
                    {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </td>
                <td>
                  <input type="date" defaultValue={(o.delivery_date || "").slice(0, 10)} onChange={(e) => e.target.value && setDelivery(o.order_id, new Date(e.target.value).toISOString())} className="admin-input text-xs" data-testid={`admin-delivery-${o.order_id}`} />
                </td>
                <td className="pr-3 text-right whitespace-nowrap">
                  {o.status === "awaiting_payment" && (
                    <button onClick={() => update(o.order_id, "confirmed")} className="text-xs uppercase tracking-widest bg-[#C5A059] text-[#121212] px-3 py-1 mr-3" data-testid={`admin-confirm-payment-${o.order_id}`}>Confirm Payment</button>
                  )}
                  <a href={`/admin/invoice/${o.order_id}`} className="text-xs uppercase tracking-widest text-[#C5A059] whitespace-nowrap" data-testid={`admin-order-invoice-${o.order_id}`}>Invoice</a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
